import { RefreshCw } from 'lucide-preact';
import { Button } from './Button';
import type { ButtonProps } from './Button';

export interface RefreshButtonProps extends Omit<
  ButtonProps,
  'variant' | 'size' | 'leftIcon' | 'rightIcon' | 'children'
> {
  /** Texto del botón. Por defecto "Actualizar datos"; solo se cambia en casos muy concretos. */
  label?: string;
}

/**
 * Botón canónico para volver a pedir los datos que enseña una página.
 *
 * Todas las cabeceras usan este mismo botón (mismo texto, icono, variante y tamaño)
 * para que "Actualizar datos" signifique lo mismo en toda la app. Las acciones que hacen
 * algo distinto (sincronizar una integración, recalcular trazas, re-auditar) NO lo usan:
 * tienen su propio texto con `Button variant="default" size="sm"`.
 */
export function RefreshButton({
  label = 'Actualizar datos',
  loading,
  ...rest
}: RefreshButtonProps) {
  return (
    <Button
      variant="default"
      size="sm"
      leftIcon={RefreshCw}
      loading={loading}
      aria-busy={loading ? true : undefined}
      {...rest}
    >
      {label}
    </Button>
  );
}
